import React, { Component } from 'react';
import { FormGroup, Input, Button, ListGroupItem, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import CounterInput from '../../components/reusable/CounterInput';
import Slider from "react-slick";
import c from '../../constants/Colors';
import Pagination from '../reusable/Pagination';
import product from '../../assets/img/product.png';
import repuestos from '../../assets/img/repuestos.png';
import { AuthContext } from "../../store/provider/AuthProvider";
import { data } from '../../constants/Constants';
import { getDataFiltros, BuscarSistemaPrincipal, BuscarSistema } from '../../store/sagas/pedidoApi';
import { AgregarProductoFavorito } from '../../store/sagas/favoritoApi';
import { AgregarProductoPedido } from '../../store/sagas/carritoApi';
import { notificacion, getStatePage } from '../../utilitarios/util';
import localStorageCustom from '../../utilitarios/localStorage';
import ModalAddCart from "../reusable/modals/AddCart";
import ModalImageZoom2 from '../reusable/modals/ImageZoom2';
import Spinner from "../reusable/Loader";
import CardPrecios from '../reusable/CardPrecios';


const CardRepuestos = ({ data, event, zoom }) => {
  return (
    <div className="card_product_horizontal">
      <div className="cphLeftImage">
        <div style={{ cursor: 'pointer' }} onClick={() => zoom(data.linkimg)}>
          <img src={data.linkimg} />
        </div>
      </div>
      <div className="cphTextCenter">
        <h6 className="paragraph-2 bold verde mb-1">{data.sistemaweb}</h6>
        {/* <Link to="/repuestos" style={{textDecoration:'none'}}> */}
        <button
          className="btn-small"
          type="button"
          onClick={() => { event(data) }}
        ><SvgAssets icon="icon-list" fill="#fff" />Ver repuestos</button>
        {/* </Link> */}
      </div>
    </div>
  )
}

const ProductoDestacado = ({ item, index, event, eventCounter, eventFavorito, pantalla, auth, zoom }) => {
  return (
    <div className="card_product_vertical" style={{ marginRight: 10 }}>
      <div style={{ cursor: 'pointer' }} onClick={() => zoom(item.fotos)}>
        <img className="product-img" src={item.pathI} />
      </div>
      <h6 className="paragraph-2 bold azul">{item.maktx}</h6>
      <span className="paragraph-3 sku">SKU: {item.matnr}</span>
      {/* <span className="paragraph-3 previousPrice">{item.previousPrice}</span>
      <span className="paragraph-3 bold" style={{ color: c.naranja }}>{item.precioPVD}</span>
      <span className="paragraph-3">{item.precioPVP}</span> */}
      <CardPrecios data={item.precios} escalas={item.escalas} cantidad={item.cantidad} className="cardPrice" />
      <div className="counter">
        <CounterInput
          background={"#fff"}
          color={"#316ACD"}
          borderColor={"#E2E2E2"}
          data={item}
          eventCounter={eventCounter}
        />
      </div>
      <div className="options">
        <button className="btn-icon"
          type="button"
          onClick={() => eventFavorito({
            codigo: item.matnr, descripcion: item.maktx,
            moneda: item.waers, pantalla: pantalla
          }, item.favorito, item.indice)}
        >
          <SvgAssets icon="icon-star" fill={item.favorito ? c.amarillo : c.celeste} />
        </button>
        <button className="btn-icon"
          type="button"
          disabled={item.cantidad == 0}
          onClick={() => event(auth.carritoProdctos, auth.setcarritoProdctos, {
            codigo: item.matnr,
            descripcion: item.maktx,
            precioOferta: item.pOfe,
            precioPublico: item.pPub,
            precioFinal: item.pFin,
            unidadMedida: item.meins,
            moneda: item.waers,
            pathI: item.pathI,
            cantidadOriginal: item.cantidad,
            cantidad: item.cantidad,
            precioPVD: item.precioPVD,
            precioPVP: item.precioPVP,
            precioPublico: item.precioPublico,
            pantalla: pantalla,
            precios: item.precios,
            escalas: item.escalas
          })}
        >
          <SvgAssets icon="icon-add-cart" className="add-cart" />
        </button>
      </div>
    </div>
  )
}

export class BuscadorVehiculo extends Component {
  static displayName = BuscadorVehiculo.name;
  static contextType = AuthContext;
  constructor(props) {
    super(props);
    this.state = {
      activeSlide: 0,
      loading: true,
      dataResult: { repuestos: [], destacados: [] },
      page: 1,
      size: data.PageSizeVehiculos,
      currentPage: 1,
      dealer: {},
      linea: {},
      asociado: {},
      filtroAnio: [],
      filtroModelo: [],
      filtroVehiculo: [],
      selectedAnioValue: null,
      selectedModeloValue: null,
      selectedVehiculoValue: null,
      selectedVehiculoValueOriginal: null,
      titulo: "",
      pdf: "",
      addToCart: false,
      dataToCard: {},
      errorVehiculo: false,
      modalZoom: false,
      imgZoom: "",
      listImgZoom: [],
    };
  }
  toggleModalZoom = (img) => {
    this.setState(prevState => ({
      modalZoom: !prevState.modalZoom,
      imgZoom: Array.isArray(img) ? "" : img,
      listImgZoom: Array.isArray(img) ? img : [],
    }));
  }
  IrBuscador = async () => {
    this.props.navigation.navigate('GenerarPedido');
  }

  render() {
    const navigation = this.props.navigation;
    const { errorVehiculo, page, size, currentPage, dataResult, titulo, pdf, activeSlide, loading, filtroAnio, filtroModelo, filtroVehiculo, selectedAnioValue, selectedModeloValue, selectedVehiculoValue } = this.state;
    const auth = this.context;

    var slider_destacados = {
      dots: false,
      infinite: true,
      arrows: false,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      variableWidth: true
    };
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <form className="busqueda-pedido" style={{ backgroundColor: c.verdeClaro }}>
          <button
            className='btn-icon btn-close'
            type="button"
            onClick={() => { this.props.history.push('/generar-pedido') }}>
            <SvgAssets icon="icon-close" fill="#fff" />
          </button>
          <FormGroup>
            <Input
              type="select"
              name="select"
              value={selectedAnioValue}
              className="verde"
              style={{ flex: 0.5 }}
              onChange={(itemValue, itemIndex) => this.setSelectedValue(itemValue, data.FiltroPedito.ComboAnio)}
            >
              <option>Año</option>
              {(filtroAnio.length > 0) ? filtroAnio.map((data, index) => {
                return (
                  <option key={index + 1} value={data.id}>{data.descripcion}</option>
                )
              }) : null}
            </Input>
            <Input type="select"
              name="select"
              value={selectedModeloValue}
              className="verde ml-2"
              onChange={(itemValue, itemIndex) => this.setSelectedValue(itemValue, data.FiltroPedito.ComboModelo)}
            >
              <option>Modelo</option>
              {(filtroModelo.length > 0) ? filtroModelo.map((data, index) => {
                return (
                  <option key={index + 1} value={data.id}>{data.descripcion}</option>
                )
              }) : null}
            </Input>
          </FormGroup>
          <FormGroup className="mb-0">
            <Input
              type="select"
              name="select"
              value={selectedVehiculoValue}
              className="verde"
              onChange={(itemValue, itemIndex) => this.setSelectedValue(itemValue, data.FiltroPedito.ComboVehiculo)}
            >
              <option>Vehículo</option>
              {(filtroVehiculo.length > 0) ? filtroVehiculo.map((data, index) => {
                return (
                  <option key={index + 1} value={data.descripcion}>{data.descripcion}</option>
                )
              }) : null}
            </Input>
            <button
              className='btn-icon rounded'
              type="button"
              onClick={() => { this.setFiler() }}
            >
              <SvgAssets icon="icon-lupa" fill="#fff" />
            </button>
          </FormGroup>
          {(errorVehiculo) ? <p className="text-danger">Debe seleccionar el año, modelo y vehículo</p> : null}
        </form>
        <Container className="py-5" style={{ backgroundColor: '#fff', position: 'relative' }}>
          <SvgAssets icon="curve-bottom" className='curve-top' fill={c.verdeClaro} />
          <div className="manual">
            <h6 className="title verde mb-0">{titulo}</h6>
            <button
              className="btn-small"
              type="button"
              onClick={() => { this.loadInBrowser() }}
            >
              <SvgAssets icon="icon-download-file" fill={c.naranja} />Descargar manual
            </button>
          </div>
          <div className="cards-wrap">
            {dataResult.repuestos.map((item, index) => {
              return (
                <CardRepuestos
                  key={index}
                  data={item}
                  event={this.loadIrRepuestos}
                  zoom={this.toggleModalZoom}
                />
              )
            })}
          </div>
          {(dataResult.repuestos.length > 0) ? <Pagination event={this.setPage} current={page} currentPage={currentPage} totalPage={dataResult.repuestos[0].totalPage} size={data.PageSizePaginator} /> : null}
          {/* <CardRepuestos />
          <CardRepuestos />
          <CardRepuestos /> */}
          {/* <Pagination /> */}
          <SvgAssets icon="curve-bottom" className='curve-bottom' fill="#fff" />
        </Container>
        <Container className="py-5 productos_destacados" style={{ backgroundColor: c.azul, position: 'relative' }}>
          <h6 className="title" style={{ color: '#fff' }}>Productos destacados</h6>
          <Slider ref={c => (this.SLIDER_DESTACADOS = c)} {...slider_destacados} >
            {dataResult != null ?
              dataResult.destacados.map((carousel, index) => {
                return (
                  <ProductoDestacado key={index} item={carousel} index={index} event={this.postAgregarProductoPedido} eventCounter={this.setCounter} eventFavorito={this.postAgregarProductoFavorito} pantalla={data.Pantalla.BuscarPedidoVehiculo.Destacado} auth={auth} zoom={this.toggleModalZoom} />
                )
              })
              : null}
            <div>
            </div>
          </Slider>
          <div className="arrows-slider">
            <button className="btn-icon" onClick={() => this.SLIDER_DESTACADOS.slickPrev()}><SvgAssets icon="icon-left" fill='#fff' /></button>
            <button className="btn-icon" onClick={() => this.SLIDER_DESTACADOS.slickNext()}><SvgAssets icon="icon-right" fill='#fff' /></button>
          </div>
        </Container>
        <ModalAddCart dadComponent={this} dataToCard={this.state.dataToCard} />
        <ModalImageZoom2 dadComponent={this} />
      </div>
    );
  }

  checkParams(fn = () => { }) {
    // debugger;
    const { state } = this.props.location;
    let parametro = state.dataParametro;

    this.setState({
      filtroAnio: parametro.filtroAnio,
      filtroModelo: parametro.filtroModelo,
      filtroVehiculo: parametro.filtroVehiculo,
      selectedAnioValue: parametro.selectedAnioValue,
      selectedModeloValue: parametro.selectedModeloValue,
      selectedVehiculoValue: parametro.selectedVehiculoValue,
      selectedVehiculoValueOriginal: parametro.selectedVehiculoValue
    }, fn);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.state !== this.props.state) {
      this.checkParams();
    }
  }

  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0)
      this.checkParams(() => {
        let data = localStorageCustom.prototype.getUsuario();
        // debugger;
        let selectedVehiculo = this.state.filtroVehiculo.filter(p => p.descripcion == this.state.selectedVehiculoValue)[0];

        this.setState({ dealer: data.dealer, linea: data.linea, asociado: data.asociado }, () => {
          this.postBuscarSistemaPrincipal(data.dealer, data.linea, data.asociado, selectedVehiculo);
        });
      });
    } else
      window.location.href = "/";
  }

  postBuscarSistemaPrincipal = (dealer, linea, asociado, selectedVehiculo) => {
    // debugger;
    BuscarSistemaPrincipal(dealer.codcliente, linea.vkorg, dealer.correoElectronico,
      selectedVehiculo.id, selectedVehiculo.descripcion, linea.centro,
      asociado.moneda, asociado.poblacion, this.state.page)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            dataResult: {
              repuestos: result.dto.sistema,
              destacados: result.dto.productosDestacados,
            },
            titulo: result.dto.sistema[0].catalogo,
            pdf: result.dto.sistema[0].linkpdf
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Buscador", error.message ?? null);
        });
      });
  }
  postBuscarSistema = async (dealer, linea, selectedVehiculo, indexPage) => {

    let _textBuscador = this.state.selectedVehiculoValue;
    let _textBuscadorOri = this.state.selectedVehiculoValueOriginal;

    if (_textBuscador != _textBuscadorOri) {
      this.setState({
        size: data.PageSize,
        currentPage: 1,
        page: 1,
        selectedVehiculoValueOriginal: _textBuscador
      })
      indexPage = 1
    }

    this.setState({ loading: true })
    BuscarSistema(dealer.codcliente, linea.vkorg, dealer.correoElectronico,
      selectedVehiculo.id, selectedVehiculo.descripcion, indexPage)
      .then(result => {
        if (result.mo.type == "success") {
          let _data = this.state.dataResult;
          this.setState({
            loading: false,
            dataResult: {
              repuestos: result.dto.sistema,
              destacados: _data.destacados
            },
            titulo: result.dto.sistema[0].catalogo,
            pdf: result.dto.sistema[0].linkpdf,
            selectedVehiculoValueOriginal: selectedVehiculo.id
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Buscador", error.message ?? null);
        });
      });
  }
  loadInBrowser = () => {
    window.open(this.state.pdf, "_blank");
    // Linking.openURL(this.state.pdf).catch(err => console.log("Couldn't load page", err));
  };
  loadIrRepuestos = (item) => {
    let datosBuscador = {
      Catalogo: item.catalogo,
      Linkimg: item.linkimg,
      Pagina: item.pagina,
      Sistemaweb: item.sistemaweb,
      addToCart: false,
      dataToCard: {}
    }

    this.props.history.push({
      pathname: '/repuestos',
      state: { datosBuscador }
    });
  };
  showModalCart = () => {
    this.setState(prevState => ({
      addToCart: !prevState.addToCart
    }));
  }
  // showCarrito = () => {
  //   this.setState({ addToCart: false, loading: false }, () => {
  //     this.props.navigation.navigate('CarritoListado');
  //   });
  // }
  showCarrito = () => {
    this.setState({ addToCart: false, loading: true }, () => {
      setTimeout(() => {
        this.setState({ loading: false })
        this.props.history.push('/carrito');
      }, 1000);
    });
  }
  setPage = (index, change, type) => {
    if (change) {
      let _currentPage = this.state.currentPage
      this.setState({ page: index, currentPage: type == "add" ? (_currentPage + 1) : (_currentPage - 1) })
    }
    else
      this.setState({ page: index })

    let selectedVehiculo = this.state.filtroVehiculo.filter(p => p.descripcion == this.state.selectedVehiculoValue)[0];
    this.postBuscarSistema(this.state.dealer, this.state.linea, selectedVehiculo, index);
  }
  setFiler = () => {
    if (this.state.selectedAnioValue == null || this.state.selectedAnioValue == "" ||
      this.state.selectedModeloValue == null || this.state.selectedModeloValue == "" ||
      this.state.selectedVehiculoValue == null || this.state.selectedVehiculoValue == "") {
      this.setState({
        errorVehiculo: true
      })
    }
    else {
      this.setState({ page: 1, errorVehiculo: false })
      let selectedVehiculo = this.state.filtroVehiculo.filter(p => p.descripcion == this.state.selectedVehiculoValue)[0];
      this.postBuscarSistema(this.state.dealer, this.state.linea, selectedVehiculo, 1);
    }
  }
  setSelectedValue(e, ETipoFiltro) {
    let value = e.currentTarget.value;
    switch (ETipoFiltro) {
      case data.FiltroPedito.ComboAnio:
        this.setState({ errorVehiculo: false, selectedAnioValue: value, filtroModelo: [], filtroVehiculo: [] })
        this.getFiltros(data.FiltroPedito.ComboModelo, value);
        break;
      case data.FiltroPedito.ComboModelo:
        this.setState({ errorVehiculo: false, selectedModeloValue: value, filtroVehiculo: [] })
        this.getFiltros(data.FiltroPedito.ComboVehiculo, this.state.selectedAnioValue, value);
        break;
      case data.FiltroPedito.ComboVehiculo:
        this.setState({ errorVehiculo: false, selectedVehiculoValue: value })
        break;
      default:
        break;
    }
  }
  getFiltros = async (ETipoFiltro, Anio, Modelo) => {
    switch (ETipoFiltro) {
      case data.FiltroPedito.ComboModelo:
        if (Anio == null || Anio == "" || Anio == undefined) return;
        break;
      case data.FiltroPedito.ComboVehiculo:
        if (Anio == null || Anio == "" || Anio == undefined ||
          Modelo == null || Modelo == "" || Modelo == undefined) return;
        break;
      default:
        break;
    }
    this.setState({ loading: true })
    getDataFiltros(ETipoFiltro, Anio, Modelo)
      .then(result => {
        if (result.mo.type == "success") {
          switch (ETipoFiltro) {
            // case data.FiltroPedito.ComboAnio:
            // this.setState({ loading: false, filtroAnio: result.dto.filtro })          
            // this.setState({ loading: false, filtroModelo: result.dto.filtro })
            // break;
            case data.FiltroPedito.ComboModelo:
              this.setState({ loading: false, filtroModelo: result.dto.filtro })
              break;
            case data.FiltroPedito.ComboVehiculo:
              this.setState({ loading: false, filtroVehiculo: result.dto.filtro })
              break;
            default:
              break;
          }
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Generar Pedidos", error.message ?? null);
        });
      });
  }
  postAgregarProductoPedido = async (carritoProdctos, setcarritoProdctos, producto) => {
    this.setState({ loading: true })

    AgregarProductoPedido(this.state.dealer, producto, this.state.linea)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false, addToCart: true, dataToCard: producto })
          // setcarritoProdctos(carritoProdctos+1);
          setcarritoProdctos(result.dto.carritoProdctos);
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Buscador", error.message ?? null);
        });
      });
  }
  setCounter = (counter, tab, index) => {
    let _data = this.state.dataResult
    let _repuestos = _data.repuestos
    let _destacados = _data.destacados


    if (counter == "") {
      if (data.Pantalla.BuscarPedidoCodigo.Producto == tab)
        _repuestos[index].cantidad = 0;
      else if (data.Pantalla.BuscarPedidoCodigo.Destacado == tab)
        _destacados[index].cantidad = 0;
    } else {
      if (data.Pantalla.BuscarPedidoCodigo.Producto == tab)
        _repuestos[index].cantidad = counter;
      else if (data.Pantalla.BuscarPedidoCodigo.Destacado == tab)
        _destacados[index].cantidad = counter;
    }
    this.setState({
      dataResult: {
        repuestos: _repuestos,
        destacados: _destacados
      }
    })

  }

  postAgregarProductoFavorito = async (producto, AplicaFavorito, index) => {
    this.setState({ loading: true })
    AgregarProductoFavorito(this.state.dealer, producto, this.state.linea, !AplicaFavorito)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false })
          let _data = this.state.dataResult
          let _destacados = _data.destacados
          let _repuestos = _data.repuestos
          _destacados[index].favorito = !AplicaFavorito;

          this.setState({
            dataResult: {
              repuestos: _repuestos,
              destacados: _destacados
            }
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Buscador", error.message ?? null);
        });
      });
  }

  setActiveSlide = (index) => {
    this.setState({ activeSlide: index })
  }
}
